import React from "react";
import { Card, Tag, Typography, Tooltip, message } from "antd";
import { UserOutlined, ShoppingCartOutlined, BookOutlined, ReadOutlined, SendOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import CartApiService from "../../services/CartApiService";
import { Role } from "../../constants/Role";
import LazyImage from "../ui/LazyImage";
import "../../styles/CourseCard.css";
const { Title, Text } = Typography;
const CourseCard = ({
  title,
  author,
  description,
  image,
  price,
  totalSections,
  category,
  slug,
  courseId,
  isPurchased = false,
  isInCart = false,
}) => {
  const navigate = useNavigate();
  const { authenticated, login, hasAnyRole } = useAuth();
  
  const handleAddToCart = async (e) => {
    e.stopPropagation(); 
    
    // Kiểm tra xem người dùng đã đăng nhập chưa
    if (!authenticated) {
      message.warning('Please login to add courses to cart!');
      login();
      return;
    }

    // Chỉ cho phép role LEARNER thêm vào cart
    if (!hasAnyRole([Role.LEARNER])) {
      message.warning('Only learners can add courses to cart!');
      return;
    }

    // Kiểm tra xem có courseId không
    if (!courseId) {
      message.error('Unable to add course to cart!');
      return;
    }

    try {
      const res = await CartApiService.addToCart(courseId);
      if (res.success) {
        message.success('Course added to cart successfully!');
        // Cập nhật cart dropdown và cart count
        window.dispatchEvent(new Event('cart-changed'));
      } else {
        message.error('Add to cart failed!');
      }
    } catch (err) {
      if (err.response?.status === 401) {
        message.error('Your session has expired. Please log in again!');
        login();
      } else {
        message.error('Add to cart failed!');
      }
    }
  };

  const handleLearnCourse = (e) => {
    e.stopPropagation();
    if (slug) {
      navigate(`/learner/my-courses/${slug}`);
    }
  };

  const handleGoToCart = (e) => {
    e.stopPropagation();
    navigate('/cart');
  };

  const handleCardClick = () => {
    if (slug) {
      if (isPurchased) {
        navigate(`/learner/my-courses/${slug}`);
      } else {
        navigate(`/courses/${slug}`);
      }
    }
  };

  return (
    <Card
      hoverable
      cover={
        <LazyImage 
          src={image} 
          alt={description} 
          className="course-image"
          height={200}
          offset={100}
        />
      }
      className="course-card"
      onClick={handleCardClick}
    >
      <Tag className="course-tag">{category}</Tag>
      <div className="course-meta">
        <Title level={5} className="course-title">
          {title.length > 80 ? (
            <Tooltip title={title} placement="topLeft">
              <span className="course-title-ellipsis">{title}</span>
            </Tooltip>
          ) : (
            <span className="course-title-ellipsis">{title}</span>
          )}
        </Title>
        <Text className="course-author">by {author}</Text>
        <div className="course-price">
          <Text strong className="course-price-value">
            ${price}
          </Text>
          {isPurchased ? (
            <ReadOutlined
              className="course-learn-icon"
              title="Learn Course"
              onClick={handleLearnCourse}
            />
          ) : isInCart ? (
            <SendOutlined
              className="course-go-to-cart"
              title="View cart"
              onClick={handleGoToCart}
            />
          ) : (
            <ShoppingCartOutlined
              className="course-add-to-cart"
              title="Add to cart"
              onClick={handleAddToCart}
            />
          )}
        </div>
      </div>
    </Card>
  );
};
export default CourseCard;
